import NodeMessaging from "messaging/NodeMessaging.js";
import MidiEffect from "../MidiEffect.js";

export default class MessageProcessor extends NodeMessaging(MidiEffect) {
    constructor(name, track) {
        super(name, track);

        this.queuedMessages = {};
    }

    newInlet(type) {
        super.newInlet(type, (msg) => this.onMessage(type, msg));
    }

    onMessage(type, msg) {
        if (!this.queuedMessages[type]) {
            this.queuedMessages[type] = [];
        }
        this.queuedMessages[type].push(msg);
        this.processMessages();
    }

    // overridden by implementation
    processMessages() {
        this.clearMessages();
    }

    getInletByNumber(number) {
        let i=0;
        for (let type in this.inlets) {
            if (i++ === number) {
                return type;
            }
        }
        return undefined;
    }

    clearMessages() {
        for (let type in this.queuedMessages) {
            this.queuedMessages[type].length = 0;
        }
    }
}


 
